const icons = {
  // locations
  home: 'home',
  work: 'work',
  other: 'place',
  transport: 'near_me',
  regular: 'sync',
  non_regular: 'sync_disabled',
  poi: 'stars',
  new: 'star_border',

  // more locations
  retail: 'store',
  grocery: 'shopping_cart',
  'bar / restaurant': 'local_bar',
  entertainment: 'movie_filter',

  // modes of transport
  car: 'directions_car',
  walking: 'directions_walk',
  biking: 'directions_bike',
  train: 'train',
  bus: 'directions_bus',
  tram: 'tram',
  subway: 'directions_subway',
  boat: 'directions_boat',
  motorcycle: 'motorcycle',
  flight: 'flight',
  running: 'directions_run',

  // time
  morning: 'brightness_5',
  afternoon: 'brightness_7',
  evening: 'brightness_medium',
  night: 'brightness_3',

  accelerate: 'trending_up',
  brake: 'trending_down',
  coast: 'arrow_upward',
  left_turn: 'subdirectory_arrow_left',
  right_turn: 'subdirectory_arrow_right',
  lane_switch: 'call_merge',
  roundabout: 'autorenew',
  phone_handling: 'phone_iphone',

  // custom event
  custom_event: 'flag',
  ecg: 'heart-pulse',
  'ecg.NSR': 'heart-pulse',
  hr: 'heart-pulse',
  steps: 'walk',
  floors: 'stairs',
  glucose: 'water',
  pressure: 'heart',
  sleep: 'hotel',
  symptoms: 'account-search',
  otc: 'pharmacy',
  recreational_product: 'flag',
  weight: 'weight',
  food: 'silverware-fork-knife',
  beverages: 'cup',
};

export default icons;
